import $ from "jquery";
import * as Cookies from "../utils/Cookies";
import React from "react";
import dispatcher from "./dispatcher.js";

// var API_LINK="http://localhost:8081/khula/API/V2/Client/";
// var GENERAL_LINK="http://localhost:8081/khula/API/V2/Admin/";
// var IMAGE_LINK="http://localhost:8081/khula/ProducePic/";
// var PROFILE_IMAGE_LINK="http://localhost:8081/khula/FarmerProfile/";
// var CLIENT_PROFILE_LINK="http://localhost:8081/khula/ClientProfile/";

// const root="http://localhost/khulaAPI/"
const root = "https://khula.co.za"
let API_LINK = `${root}/API/V2/Client/`;
let GENERAL_LINK = `${root}/API/V2/Admin/`;
let IMAGE_LINK = `${root}/ProducePic/`;
let PROFILE_IMAGE_LINK = `${root}/FarmerProfile/`;
let CLIENT_PROFILE_LINK = `${root}/ClientProfile/`;

export function getActiveOrders() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "getOngoingOrders",
            token: Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({
                        type: "RECEIVE_ALL_ACTIVE_ORDERS",
                        activeOrders: $.grep(data.data, function (n, i) {
                            return n.state == "0";
                        })
                    }
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function getReadyForDelivery() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "getOngoingOrders",
            token: Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            console.log(data);
            if (data.success == 1) {
                dispatcher.dispatch({
                        type: "RECEIVE_ALL_READY_FOR_DELIVERY_ORDERS",
                        readyOrders: $.grep(data.data, function (n, i) {
                            return n.state == "1";
                        })
                    }
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function getCompletedOrders() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "getCompletedOrders",
            token: Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {

                dispatcher.dispatch({type: "RECEIVE_ALL_COMPLETED_ORDERS", completedOrders: data.data}
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function searchFarmerWithFilters(sendData) {
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({type: "RECEIVE_ALL_SEARCH_FARMERS", searchFarmers: data.data}
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function searchFarmer(searchText) {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "searchFarmers",
            token: Cookies.checkCookie("accessToken"),
            searchText: searchText
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({type: "RECEIVE_ALL_SEARCH_FARMERS", searchFarmers: data.data}
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function getMyPreferredFarmers() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "getMyFarmers",
            token: Cookies.checkCookie("accessToken")
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({type: "RECEIVE_MY_PREFERRED_FARMERS", myFarmers: data.data}
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function addToMyPreferredFarmers(farmer) {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "addPreferedSupplier",
            token: Cookies.checkCookie("accessToken"),
            farmerId: farmer.id,
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({type: "ADD_TO_PREFERRED_FARMERS", searchFarmers: data.data, farmer: farmer}
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function removeFromMyPreferredFarmers(farmerId) {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "removePreferedSupplier",
            token: Cookies.checkCookie("accessToken"),
            farmerId: farmerId
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({
                        type: "REMOVE_FROM_PREFERRED_FARMERS",
                        searchFarmers: data.data,
                        farmerId: farmerId
                    }
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function getMyProfile() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "getMyProfile",
            token: Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({type: "RECEIVE_MY_PROFILE", profile: data.data}
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function getMyProfileEdit() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "getMyProfile",
            token: Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({
                        type: "RECEIVE_MY_PROFILE_EDIT",
                        profile: data.data,
                        completed: data.completed,
                        farmers: data.farmers,
                        pending: data.pending
                    }
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function getAllInvoice() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "getAllInvoices",
            token: Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            console.log(data);
            if (data.success == 1) {
                dispatcher.dispatch({
                        type: "RECEIVE_ALL_INVOICE_DETAILS",
                        invoiceKeys: data.keys,
                        invoiceData: data.data
                    }
                );
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // logout here
            }
        });
}

export function getProduceList() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "get_produce",
            token: Cookies.checkCookie("accessToken"),
        })

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            console.log(data)
            // if(data.success==1) {
                dispatcher.dispatch({type: "RECEIVE_ALL_PRODUCE", produceData: data.data});
            // }
            //logoutAuto()
        });
}

export function getProduceListView() {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param({
            type: "admin_get_produce_inventory",
        })

    };

    fetch(GENERAL_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            if (data.success == 1) {
                dispatcher.dispatch({
                    type: "RECEIVE_ALL_PRODUCE_VIEW_INVENTORY", produceData: $.grep(data.data, function (n, i) {
                        return n.quantity != "0";
                    })
                });
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
            }
        });
}

export function loginClient(data, remember) {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param(data)

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            console.log(data)
            if (data.success == 1) {
                Cookies.setCookie("accessToken", data.token);

                Cookies.setCookie("rememberMe", remember);
                Cookies.setCookie("profileName", data.name);
                dispatcher.dispatch({type: "RECEIVE_LOGIN_SUCCESSFUL", loginData: data});
            } else {
                //logoutAuto()
            }
        });
}

export function updateProfile(dataS) {
    var sendData = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: $.param(dataS)

    };
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {

            if (data.success == 1) {
                Cookies.setCookie("profileName", dataS.name);
                dispatcher.dispatch({type: "RECEIVE_PROFILE_UPDATE_SUCCESSFUL", residueData: dataS});
            } else {
                console.log("Logging out")
                alert(data.message);
                //logoutAuto()
                // this.logoutUser()
            }
        });
}

export function updateImage(sendData) {
    fetch(API_LINK, sendData)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {

            alert('Image Updated');
        });
}

function logoutAuto() {
    Cookies.deleteCookie('accessToken');
    Cookies.deleteCookie('profileName');
    Cookies.deleteCookie('rememberMe');
    // this.props.history.push('/login');
    // window.location.replace("http://localhost:3000/login");

}

export function getLinkLocation() {
    return API_LINK;
}

export function getProduceImageLink() {
    return IMAGE_LINK;
}

export function getClientProfileLink() {
    return CLIENT_PROFILE_LINK;
}

export function getProfileImageLink() {
    return PROFILE_IMAGE_LINK;
}

export function getGeneralAPILink() {
    return GENERAL_LINK;
}

export function performNetworkOperation(body, callback, error) {
    fetch(GENERAL_LINK, body)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            console.log(data)
            if (data.success == 1) {
                callback(data.data)
            } else {
                error(data.success)
            }

        });
}

export function performNetworkOperationClientSecure(body, callback, error) {
    fetch(API_LINK, body)
        .then((resp) => resp.json()) // Transform the data into json
        .then(function (data) {
            console.log(data)
            if (data.success == 1) {
                callback(data.data)
            } else {
                error(data.success)
            }

        });
}


// WEBPACK FOOTER //
// ./src/utils/Connections.js